import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { getPaymentRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { CampusCardInstitution } from '~types';

type Options = {
  enabled?: boolean;
};

export const useQueryGetInstitution = (
  uuid?: string | null,
  { enabled = true }: Options = {},
) => {
  return useQuery<CampusCardInstitution>(
    [QUERY_KEY.GET_CAMPUS_CARD_INSTITUTION, uuid],
    () =>
      getPaymentRequest<CampusCardInstitution>({
        path: `api/campus-card/institution/${uuid}`,
      }),
    {
      enabled: enabled && !!uuid && !!inMemoryJWTService.getCurrentToken(),
    },
  );
};
